import { formatAmount } from "../../utils/functions";
import { MUIStyled } from "../MUIStyled";
import SATypography from "../SATypography";

const StyledAmount = MUIStyled(SATypography)({
  borderRadius: "6px",
  display: "inline-block",
  color: "#027A48",
  fontWeight: 600,
});

const SACost = ({ value, compact = true, ...props }) => {
  return (
    <StyledAmount variant="body2" {...props}>
      {`${formatAmount(value, compact)}`}
    </StyledAmount>
  );
};

export default SACost;
